module.exports = __webpack_public_path__ + "static/img/banner_img.e248579b.png";